import * as React from "react";

import { StepsPropsTyped } from "@impero-com/common/components/applicationBar/applicationBar";
import { BreadcrumbSpec } from "@impero-com/common/componentTypes/breadcrumb";
import { t } from "@impero-com/common/utils/i18n";

import { OrgApplicationBar } from "../../../../components/applicationBar/orgApplicationBar";
import { WebRoute } from "../../../../routes";

export const USER_GROUP_CREATE_DETAILS_STEP = "USER_GROUP_CREATE_DETAILS";
export const USER_GROUP_CREATE_MEMBERS_STEP = "USER_GROUP_CREATE_MEMBERS";

type UserGroupCreationStep =
    | typeof USER_GROUP_CREATE_DETAILS_STEP
    | typeof USER_GROUP_CREATE_MEMBERS_STEP;

interface UserGroupsCreateApplicationBarProps {
    currentStepId: UserGroupCreationStep;
    canCreate: boolean;
    children: React.ReactNode;
}

class UserGroupsCreateApplicationBar extends React.PureComponent<UserGroupsCreateApplicationBarProps> {
    static defaultProps = {
        userGroup: null,
        actions: [],
    };

    buildTitle = (): BreadcrumbSpec => {
        return {
            title: t("UserGroup_Management_CreateUserGroup"),
            breadCrumbs: [
                {
                    label: t("UserManagement_ModuleTitle"),
                    url: WebRoute.USERS,
                },
                {
                    label: t("UserManagement_Groups"),
                    url: WebRoute.USER_GROUPS,
                },
            ],
        };
    };

    render = () => {
        const { children, currentStepId, canCreate } = this.props;

        let navigation: StepsPropsTyped | undefined;
        if (canCreate) {
            navigation = {
                type: "Steps",
                limitedWidth: true,
                currentStepId,
                stepSpecs: [
                    {
                        id: USER_GROUP_CREATE_DETAILS_STEP,
                        label: t("UserManagement_Groups_DetailsTab"),
                        onClick: () => {},
                    },
                    {
                        id: USER_GROUP_CREATE_MEMBERS_STEP,
                        label: t("UserManagement_Groups_MembersTab"),
                        onClick: () => {},
                    },
                ],
            };
        }

        return (
            <OrgApplicationBar
                title={this.buildTitle()}
                actions={{
                    id: "user-group-create-actions",
                    actions: [],
                }}
                navigation={navigation}
            >
                {children}
            </OrgApplicationBar>
        );
    };
}

export { type UserGroupCreationStep, UserGroupsCreateApplicationBar };
